import type { Node } from 'reactflow';

/**
 * TH-1 — decorate the greeting's child-turn node with the flash class so the
 * canvas animates the sherpa's first words. Pure: a null id returns the input
 * array by reference (RF11 identity fast-path survives). Flash is a CSS class
 * only — never style.transform (that fights ReactFlow's pan/zoom transform).
 */
export function decorateGreetingFlash(nodes: Node[], greetingFlashId: string | null): Node[] {
  if (!greetingFlashId) return nodes;
  return nodes.map((n) => {
    const mid = (n.data as any)?.messageId ?? (n.data as any)?.spineRootMessageId;
    return mid === greetingFlashId
      ? { ...n, className: `${n.className ?? ''} chatmap-greeting-flash`.trim() }
      : n;
  });
}
